import { render, staticRenderFns } from "./KT-Map.vue?vue&type=template&id=2a4f7406&"
import script from "./KT-Map.vue?vue&type=script&lang=js&"
export * from "./KT-Map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports